import { EffectiveThemeType, ThemeType } from '../types';
export function getEffectiveThemeMode(userThemeType) {
    if (userThemeType == ThemeType.DARK) {
        return EffectiveThemeType.DARK;
    }
    if (userThemeType == ThemeType.LIGHT) {
        return EffectiveThemeType.LIGHT;
    }
    //Высчитываем тёмную тему для приложения или браузера
    const isReallyDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return isReallyDark ? EffectiveThemeType.DARK : EffectiveThemeType.LIGHT;
}
